import { QUESTIONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// 1 duplicate
const duplicate_question_request = () => {
  return {
    type: questionsTypes.duplicate.request
  }
}

const duplicate_question_success = (response) => {
  return {
    type: questionsTypes.duplicate.success,
    payload: response.data
  }
}

const duplicate_single_question_success = (response) => {
  return {
    type: questionsTypes.duplicate.single,
    payload: response.data
  }
}

const duplicate_question_failure = (messages) => {
  return {
    type: questionsTypes.duplicate.failure,
    payload: messages
  }
}

const duplicate_question = (question_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( duplicate_question_request() )
    const reqParams = index ? {
      index: index,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: index}
    // Request
    axios.post(
      formatRoute(QUESTIONS_ROUTES.duplicate, {id: question_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The question has been duplicated.')
      if ( index ) {
        dispatch( duplicate_question_success(response) )

      } else {
        dispatch( duplicate_single_question_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error duplicating question"]
      }
      dispatch( duplicate_question_failure( errors ) )
    })
  }
}

export {duplicate_question}



// WEBPACK FOOTER //
// ./src/js/actions/questions/duplicate.js